import { Card, Grid, Typography } from '@material-ui/core'
import { Error, ListButton, Loading, SimpleShowLayout, useQueryWithStore } from 'react-admin'
import { usePageTitle } from 'shared/components/PageTitle/PageTitle'

import { LabeledTypographyField } from 'components/Fields'

export const SFMSHomepageShow = (props: any) => {
  const { loaded, error, data } = useQueryWithStore({
    type: 'getOne',
    resource: 'sfms/homepage',
    payload: { id: 'show' },
  })
  usePageTitle('Shipper loads')

  if (!loaded) return <Loading />
  if (error) return <Error error={error} />
  if (!data) return null

  const {
    waiting_for_tender_decision: waitingForTenderDecision,
    waiting_for_driver_assignment: waitingForDriverAssignment,
    pickup_at_risk: pickupAtRisk,
    invoicing_needed: invoices,
    unscheduled,
  } = data

  return (
    <>
      <SimpleShowLayout>
        <Card style={{ padding: 20 }}>
          <Grid container direction="column" justifyContent="flex-start" alignItems="flex-start" spacing={2}>
            <Grid item xs={12}>
              <Typography component="span" variant="h5" color="textPrimary">
                Summary
              </Typography>
            </Grid>
            <Grid container item direction="row">
              <Grid item xs={4}>
                <LabeledTypographyField
                  label="Waiting For Tender Decision"
                  variant="body1"
                  value={
                    <ListButton
                      basePath="/sfms/waiting-tender-decision"
                      label={`${waitingForTenderDecision}`}
                      {...props}
                    />
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <LabeledTypographyField
                  label="Unscheduled"
                  variant="body1"
                  value={<ListButton basePath="/sfms/scheduling" label={`${unscheduled}`} {...props} />}
                />
              </Grid>

              <Grid item xs={4}>
                <LabeledTypographyField
                  label="Waiting For Driver Assignment"
                  variant="body1"
                  value={
                    <ListButton
                      basePath="/sfms/driver-assignment"
                      label={`${waitingForDriverAssignment}`}
                      {...props}
                    />
                  }
                />
              </Grid>
              <Grid item xs={2}>
                <LabeledTypographyField
                  label="Pickup At Risk"
                  variant="body1"
                  value={<ListButton basePath="/sfms/pickup-at-risk" label={`${pickupAtRisk}`} {...props} />}
                />
              </Grid>
              <Grid item xs={2}>
                <LabeledTypographyField
                  label="Invoice Needed"
                  variant="body1"
                  value={<ListButton basePath="/sfms/invoices" label={`${invoices}`} {...props} />}
                />
              </Grid>
            </Grid>
          </Grid>
        </Card>
      </SimpleShowLayout>
    </>
  )
}
